var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBhimUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 2.66895L12 30.0023L26.6667 16.0023L19.3333 2.66895Z",
    fill: "#388E3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 2.00195L6.6665 29.3353L21.3332 15.3353L13.9998 2.00195Z",
    fill: "#F57C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhimUpi);
export default __webpack_public_path__ + "static/media/bhim-upi.8493e833ede3110eb745433bdb8d3ee7.svg";
export { ForwardRef as ReactComponent };